import { Injectable } from '@angular/core';
@Injectable()
export class NewUserModel {
  username: string;
  roleId: number;
  email: string;
}
